import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MappedSubscriberDto } from '@models/users/mapped-subscriber.dto';
import { SubscriberService } from '@services/subscriber.service';
import {
  NgxScannerQrcodeComponent,
  ScannerQRCodeDevice,
} from 'ngx-scanner-qrcode';

@Component({
  selector: 'ebs-agreed-user',
  templateUrl: './agreed-user.component.html',
  styleUrls: ['./agreed-user.component.scss'],
})
export class AgreedUserComponent implements AfterViewInit, OnDestroy {
  formGroup!: FormGroup;

  public search: string = '';

  public devices: ScannerQRCodeDevice[] = [];
  public selectedDevice?: ScannerQRCodeDevice;

  public users: MappedSubscriberDto[] = [];
  public user?: MappedSubscriberDto;
  public isValid: boolean = false;
  public isScannerActive: boolean = false;
  public searchDone: boolean = false;

  @ViewChild('action')
  scanner!: NgxScannerQrcodeComponent;

  constructor(private subsService: SubscriberService) {
    this.formGroup = new FormGroup({
      search: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9A-Z]*$'),
          Validators.maxLength(6),
          Validators.minLength(6),
        ]),
      ),
    });
    subsService.getAgreedSubscribers().subscribe((result) => {
      this.users = result;
    });
  }
  ngAfterViewInit(): void {}
  ngOnDestroy(): void {
    if (this.isScannerActive && this.scanner.isStart) {
      this.scanner.stop();
    }
  }

  @HostListener('window:keydown.enter', ['$event'])
  onKeyPress(evt) {
    if (evt.key === 'Enter' && this.formGroup.valid) {
      this.validateExternalCode();
    }
  }

  validateExternalCode() {
    this.user = this.users.find((elem) => elem.externalCode === this.search);
    this.isValid = this.user !== undefined;
    this.searchDone = true;
  }

  toggleScan() {
    if (this.isScannerActive) {
      this.scanner.stop();
      this.isScannerActive = false;
      this.devices = [];
      this.selectedDevice = undefined;
    } else {
      this.isScannerActive = true;
      setTimeout(() => {
        // navigator.mediaDevices.enumerateDevices()
        this.scanner.devices.subscribe((res) => {
          this.devices = res;
          if (!this.scanner.isStart) {
            this.scanner.start();
            this.scanner.data.subscribe((data) => {
              if (data[0] !== undefined && data[0].value !== undefined) {
                this.search = data[0].value;
                if (this.formGroup.valid) {
                  this.validateExternalCode();
                  this.toggleScan();
                }
              }
            });
          }
        });
      }, 1200);
    }
  }
}
